<input class="form-control form-control-sm" type="text" [formControl]="valueControl" [placeholder]="placeholder" />